export default {
    convertToBase64(url: string, callback: any): void {
        const img = new Image();

        img.onload = function() {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx?.drawImage(img, 0, 0);
            const dataUrl = canvas.toDataURL('image/png');

            callback(dataUrl);
        };

        img.setAttribute('crossOrigin', 'anonymous');
        img.src = url;
    }
};
